import { z } from 'zod';
import { ISODateString } from 'shared/src/date-string-utils/types';

export const PlatformBuyMetric = z.object({
  bucket: ISODateString,
  line_item_id: z.uuid(),
  media_buy_id: z.string().nullable(),
  actual_delivered_units: z.coerce.number(),
  actual_delivered_units_cumulative: z.coerce.number(),
  actual_media_spend: z.coerce.number(),
  actual_media_spend_cumulative: z.coerce.number(),
  unit_cost_incurred: z.coerce.number(),
  unit_cost_incurred_cumulative: z.coerce.number(),
  total_target_units: z.coerce.number(),
  current_target_units: z.coerce.number(),
  delivery_pacing: z.coerce.number(),
  total_planned_spend: z.coerce.number(),
  current_planned_spend: z.coerce.number(),
  spend_pacing: z.coerce.number(),
  revenue: z.coerce.number(),
  total_target_revenue: z.coerce.number(),
  planned_revenue: z.coerce.number(),
  price: z.coerce.number(),
  effective_price: z.coerce.number(),
  gross_price: z.coerce.number(),
  current_margin: z.coerce.number(),
  planned_margin: z.coerce.number(),
  line_item_budget: z.coerce.number(),
  estimated_units: z.coerce.number()
});
export type PlatformBuyMetric = z.infer<typeof PlatformBuyMetric>;

export const LineItemMetric = PlatformBuyMetric.omit({ media_buy_id: true }).extend({
  unit_cost_variance: z.coerce.number()
});
export type LineItemMetric = z.infer<typeof LineItemMetric>;

export const LineItemMetricV2 = z.object({
  line_item_id: z.uuid(),
  delivery_pacing: z.coerce.number(),
  on_pace_units: z.coerce.number(),
  actual_delivered_units: z.coerce.number(),
  unit_cost_actual: z.coerce.number(),
  spend_pacing: z.coerce.number(),
  on_pace_spend: z.coerce.number(),
  actual_media_spend: z.coerce.number(),
  margin_actual: z.coerce.number(),
  target_margin: z.coerce.number().nullable(),
  planned_margin: z.coerce.number().nullable(),
  unit_price_type_name: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  estimated_units: z.coerce.number(),
  media_budget: z.coerce.number(),
  planned_unit_cost: z.coerce.number(),
  margin_variance_rate: z.coerce.number(),
  unit_cost_variance_rate: z.coerce.number(),
  units_delivered_rate: z.coerce.number(),
  budget_spent_rate: z.coerce.number(),
  units_remaining: z.coerce.number(),
  budget_remaining: z.coerce.number()
});
export type LineItemMetricV2 = z.infer<typeof LineItemMetricV2>;

export const CampaignMetrics = z.object({
  strategy_id: z.string().optional(),
  campaign_id: z.string().optional(),
  delivery_pacing: z.coerce.number(),
  spend_pacing: z.coerce.number(),
  on_pace_spend: z.coerce.number(),
  actual_media_spend: z.coerce.number(),
  planned_spend: z.coerce.number(),
  margin_actual: z.coerce.number(),
  target_margin: z.coerce.number().nullable(),
  planned_margin: z.coerce.number().nullable(),
  on_pace_revenue: z.coerce.number(),
  effective_billable_revenue: z.coerce.number()
});
export type CampaignMetrics = z.infer<typeof CampaignMetrics>;

export const MediaPlanMetrics = z.object({
  media_plan_id: z.uuid(),
  line_item_id: z.uuid(),
  media_buy_id: z.uuid(),
  target_margin: z.coerce.number(),
  actual_delivered_units: z.coerce.number(),
  actual_media_spend: z.coerce.number(),
  media_revenue_earned: z.coerce.number(),
  unit_cost_incurred: z.coerce.number(),
  percent_units_delivered: z.coerce.number(),
  current_margin: z.coerce.number()
});
export type MediaPlanMetrics = z.infer<typeof MediaPlanMetrics>;
